import _ from "lodash";
import { onError } from "@apollo/client/link/error";

import { logGraphqlBreadcrumb, isUserBlocked } from "services/sentry/errors";
import {
  logoutUser,
  setUnderMaintenanceState,
} from "Login/modules/LoginModule";
import { globalErrorHandler } from "services/sentry/globalErrorHandler";

const errorLink = onError(errorHandler => {
  const { networkError } = errorHandler;
  // If user is blocked, we don't want to logout the user instead redirect user to user-blocked page (this is handled in globalErrorHandler)
  if (
    networkError &&
    networkError.statusCode === 401 &&
    !isUserBlocked(networkError)
  ) {
    logoutUser({
      skipLogoutCall: true,
    });
    return;
  }

  if (_.get(networkError, "result.id", null) == "SERVER_UNDER_MAINTENANCE") {
    setUnderMaintenanceState({
      value: _.get(networkError, "result.data", null),
    });
    return;
  }

  globalErrorHandler(errorHandler);
  if (isUserBlocked(networkError)) return; // Don't log this error in sentry if user is blocked
  logGraphqlBreadcrumb({ data: errorHandler });
});

export default errorLink;
